export interface InterfaceMarkerPoint {
    latitude: number
    longitude: number
    id?: any
}
export interface InterfaceMarkerLine extends Array<InterfaceMarkerPoint> { }

export interface InterfaceFieldingMarker {
    lineData: Array<InterfaceMarkerLine>
    shapeData: Array<InterfaceMarkerLine>
    dotLongLat: string
    colorCode: string
    subject: string
    notes: string
    timeOffset: number
    requestedFielding: string
    requestedAmountType: null | 0 | 1
    requestedAmountTypeString: any
    actualFielding: string
    customTypeId: any
    customTypeString: string | null
    id?: string
    images?: Array<InterfaceFieldingDetailMarkerAttachment>
    frontyard: number
    backyard: number
    noAccessPole: number
    underground: number
    structures: number
    noAccessStructures: number
    structuresNotInField: number
    progressPercentage?: number
}

export interface InterfaceFieldingMarkerProgress {
    customTypeId: string
    progressPercentage: number,
    sliderProgressPercentage: number,
    fieldingRequestActualFielding: string | null,
    frontyard: number,
    backyard: number,
    noAccessPole: number,
    underground: number,
    structures: number,
    noAccessStructures: number,
    structuresNotInField: number
}

export interface InterfaceFieldingMarkerList extends Array<InterfaceFieldingMarker> { }

export interface InterfaceFieldingMarkerProgrestList extends Array<InterfaceFieldingMarkerProgress> { }

export const InitialFieldingMarker: InterfaceFieldingMarker = {
    lineData: [],
    shapeData: [],
    dotLongLat: "",
    colorCode: "",
    subject: "",
    notes: "",
    timeOffset: 0,
    requestedFielding: "",
    requestedAmountType: null,
    requestedAmountTypeString: null,
    actualFielding: "",
    customTypeId: null,
    customTypeString: null,
    frontyard: 0,
    backyard: 0,
    noAccessPole: 0,
    underground: 0,
    structures: 0,
    noAccessStructures: 0,
    structuresNotInField: 0
}

export interface InterfaceFieldingNotes {
    id: string
    createdById: string
    createdDateString: string
    content: string
    fielderIds: Array<string>
    fielderNames: Array<string>
    comments: Array<{
        comment: string
        name: string
        dateTimeString: string
    }>
}

export interface InterfaceFiledingType {
    id: string
    name: string
}
export interface InterfaceFiledingTypeList extends Array<InterfaceFiledingType> { }

export interface InterfaceFieldingEdit {
    token: string
    fieldingRequestId: string
    fielderIds: Array<string>
    dueDateString: string
    colorCode: string
    customTypeId: any
    requestedStartDateString: string | null
    requestedDueDateString: string | null
    editedFieldingRequestMarkers: Array<{
        timeOffset: number
        fieldingRequestMarkerId: string
        lineData: string
        dotLongLat: string
        colorCode: string
        subject: string
        notes: string
    }>,
    isEndMarker: boolean
}

export interface InterfaceFieldingDataDetail {
    fieldingRequestId: string
    fieldingRequest: string
    dueDate: string
    createdDate: string
    totalPoles: number
    totalCompletedPoles: number
    status: string
    fieldingProgress: string
    firstPoleLongLat: string
    type: number
    lastUpdate: string
    fieldingCategory: number
    totalMeasurementMarkers: number
    totalCompletedMeasurementMarkers: number
    firstMeasurementMarkerLongLat: string
    firstMarkerLocation: string
    fieldingRequestNotes: Array<InterfaceFieldingNotes>
    averageProgressPercentage: number
    milesTotal: number
    isClaimed: boolean
    externalLinks: Array<string>
}
export interface InterfaceFieldingData {
    jobNumberId: string
    projectId: string
    title: string
    lastFieldingRequestDueDate: string
    fieldingRequestCount: number
    notif: string
    jobStatus: number,
    isHotJob: boolean,
    details: Array<InterfaceFieldingDataDetail>
}

export interface InterfaceFieldingDataByDistance {
    jobNumberId: string
    projectId: string
    title: string
    lastFieldingRequestDueDate: string
    fieldingRequestCount: number
    notif: string
    jobStatus: number,
    isHotJob: boolean,
    isReactivated?: boolean,
    isNearest?: boolean,
    details: Array<InterfaceFieldingDataDetail & { distance: number }>
}
export interface InterfaceFieldingDataList extends Array<InterfaceFieldingData> { }

export interface InterfaceFieldingDetailAttachment {
    id: string
    fieldingRequestId: string
    fieldingRequest: string
    fileName: string
    fileNameWithExt: string
    filePath: string
    isOfficeUpload: true
    selectedUploadTimeOffset: number
    detectedImageTakenDate: string
    createdDate: string
    uploadDateString: string
    createdById: string
    uploadedBy: string
    convertedDetectedImageTakenDate: string
}
export interface InterfaceFieldingDetailMarkerAttachment {
    id: string
    fileType: number
    fileName: string
    filePath: string
    selectedUploadTimeOffset: number
    detectedImageTakenDate: string
    fileLength: number
    serverDetectedImageTakenDate: string
    uploadDateString: string
    uploadedBy: string
}

export interface InterfaceDownloadLog {
    downloadedDate: string
    downloadedTime: string
    userName: string
    travelLogs: Array<InterfaceDownloadTravelLog>
    selected?: InterfaceDownloadTravelLog
    locationLogs: Array<InterfaceDownloadLocationLog>
}
export interface InterfaceFieldingLog {
    startDate: string
    endDate: string
    createdBy: string
}
export interface InterfaceDownloadTravelLog {
    dateTime: string
    miles: number,
    claimerId: string,
    initialLocation: string,
    nextLocation: string
}
export const InitialDownloadTravelLog: InterfaceDownloadTravelLog = {
    dateTime: "",
    miles: 0,
    claimerId: "",
    initialLocation: "",
    nextLocation: ""
}
export interface InterfaceDownloadLocationLog {
    dateTime: string
    longLat: string
}

export interface InterfaceFieldingDetail {
    id: string
    projectId: string
    name: string
    project: string
    dueDateString: string
    colorCode: string
    firstMarkerLocation: string
    completedFielderIds: Array<string>
    fielderIds: Array<string>
    ftrFielderIds: Array<string>
    ftrFielderQuantity: number
    fielderNames: Array<string>
    mobileDownloadLogs: Array<InterfaceDownloadLog>
    fieldingRequestMarkerFieldingLogs: Array<{
        startDate: string
        endDate: string
        createdBy: string
    }>
    fieldingRequestAttachments: Array<InterfaceFieldingDetailAttachment>
    fieldingRequestMarkerImages: Array<InterfaceFieldingDetailMarkerAttachment>
    projectDocuments: Array<string>
    projectLinks: Array<string>
    fieldingRequestMarkers: InterfaceFieldingMarkerList
    fieldingRequestMarkersProgress: InterfaceFieldingMarkerProgrestList
    customTypeId: any
    customTypeString: string | null
    projectLocation: string
    projectLocationExtent: {
        xmin: string
        ymin: string
        xmax: string
        ymax: string
    }
    requestedStartDateString: string
    requestedDueDateString: string
    fieldingRequestNotes: Array<InterfaceFieldingNotes>
    externalLinks: Array<string>
}

export interface InterfaceFieldingAssignedActive {
    id: string
    name: string
    project: string
    colorCode: string
    firstMarkerLocation: string,
    isHotJob: boolean,
    fieldingRequestNotes: Array<InterfaceFieldingNotes>
}

export interface InterfaceFieldingAssignedActiveList extends Array<InterfaceFieldingAssignedActive> { }

export const InitialFieldingDetail: InterfaceFieldingDetail = {
    id: "",
    projectId: "",
    name: "",
    project: "",
    dueDateString: "",
    colorCode: "",
    firstMarkerLocation: "",
    fielderIds: [],
    completedFielderIds: [],
    ftrFielderIds: [],
    ftrFielderQuantity: 0,
    fielderNames: [],
    mobileDownloadLogs: [],
    fieldingRequestMarkerFieldingLogs: [],
    fieldingRequestAttachments: [],
    fieldingRequestMarkerImages: [],
    projectDocuments: [],
    projectLinks: [],
    fieldingRequestMarkers: [],
    fieldingRequestMarkersProgress: [],
    customTypeId: "",
    customTypeString: "",
    projectLocation: "",
    projectLocationExtent: {
        xmin: "",
        ymin: "",
        xmax: "",
        ymax: ""
    },
    requestedStartDateString: "",
    requestedDueDateString: "",
    fieldingRequestNotes: [],
    externalLinks: [],
}

export interface InterfaceFieldingNameList
    extends Array<{
        id: string
        name: string
    }> { }

export interface InterfaceToolNameList
    extends Array<{
        id: string
        name: string
    }> { }

export interface InterfaceFieldingMarkerAdd {
    id: ""
    fieldingRequestId: string
    type: 0
    lineData: string
    shapeData: string
    subject: string
    notes: string
    markerColor: 0
    dotLongLat: string
    colorCode: string
    timeOffset: number
    customTypeId: string | any | undefined
    requestedFielding: string | any | undefined
}

export interface InterfaceFieldingNoteCreate {
    token: string
    content: string
    fielderIdList: Array<string>
    fieldingRequestId: string
}
export const InitialFieldingNoteCreate: InterfaceFieldingNoteCreate = {
    token: "",
    content: "",
    fielderIdList: [],
    fieldingRequestId: ""
}

export interface InterfaceFieldingNoteCommentCreate {
    token: string
    comment: string
    fieldingRequestNoteId: string
}

export interface InterfaceFieldingAssignFtr {
    token: string
    fieldingRequestId: string
    fielderIds: Array<string>
    ftrFielderQuantity: number
}

export interface InterfaceFieldingNotification {
    fieldingRequestId: string
    fieldingRequest: string
    project: string
    assignedDate: string
    assignedTime: string
    isRead: boolean
    sortDate: string
    fieldingRequestNoteId: string
    from: string
    content: string
    isFirstToReceive: boolean
    fieldingRequestDueDate: string
    fieldingRequestRequestedStartDate: string
    fieldingRequestRequestedDate: string
    isHotJob: Boolean
    notes: string
    isReactivated: Boolean
    category: string
    assignFielderConfirmationId: string
}

export interface InterfaceWorkDateConfirmation {
    token: string
    id: string
    acceptedStartDate: string
    acceptedEndDate: string
    isAccepted: boolean
}
export const InitialWorkDateConfirmation: InterfaceWorkDateConfirmation = {
    token: "",
    id: "",
    acceptedStartDate: "",
    acceptedEndDate: "",
    isAccepted: false
}

export interface InterfaceUploadLink {
    token: string
    id: string
    newLinks: Array<string>
}